import UserContext from "@whitespace/gatsby-theme-smorgasbord/src/contexts/userContext";
import PropTypes from "prop-types";
import React, { useEffect, useState, useContext } from "react";
import { useFetch } from "use-http";

import EdpContext from "../contexts/edpContext";

EdpProvider.propTypes = {
  children: PropTypes.node,
  apiPath: PropTypes.string.isRequired,
};

export default function EdpProvider({ children, apiPath }) {
  const { error, get, loading = true } = useFetch(apiPath);
  const { user } = useContext(UserContext);
  const [buildings, setBuildings] = useState();
  const [selectedBuilding, setSelectedBuilding] = useState();
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState();

  useEffect(async () => {
    if (!user?.edpCustomer) return null;
    const response = await get("/buildings");
    if (response) {
      const { data: { buildings = [] } = {} } = response;
      if (buildings.length) {
        setBuildings(buildings);
        setSelectedBuilding(buildings?.[0]);
      }
    }
  }, [JSON.stringify(user), JSON.stringify(user?.edpCustomer)]);

  useEffect(async () => {
    if (!selectedBuilding) return;
    const response = await get(`/buildings/${selectedBuilding.id}`);
    if (response) {
      const { data: { services = [] } = {} } = response;
      if (services.length) {
        setServices(services);
        setSelectedService(services?.[0]);
      }
    }
  }, [JSON.stringify(selectedBuilding)]);

  return (
    <EdpContext.Provider
      value={{
        apiPath,
        services,
        selectedService,
        setSelectedService,
        buildings,
        selectedBuilding,
        setSelectedBuilding,
        pending: loading,
        error,
      }}
    >
      {children}
    </EdpContext.Provider>
  );
}
